import React from 'react';
import { useTheme } from '@material-ui/core';
import FormML from './FormML';
import StepOneStyled from './StepOneMLStyles';

export default (props) => {
  const theme = useTheme();
  return (
    <StepOneStyled theme={theme}>
      <FormML {...props} />
    </StepOneStyled>
  );
};
